module.exports = __webpack_public_path__ + "static/media/mario-mushroom-transparent.c7541344.png";